var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("div", { staticClass: "row align-bottom margin-bottom-md" }, [
            _c("div", { staticClass: "column-12 laptop:column-8" }, [
              _vm.hasArrivedFromFigma
                ? _c(
                    "label",
                    {
                      staticClass: "margin-0 display-inline-block",
                      staticStyle: {
                        cursor: "pointer",
                        "font-weight": "700",
                        color: "var(--fa-dk-gravy)",
                      },
                      attrs: { for: "email" },
                    },
                    [
                      _vm._v(
                        "\n          Enter your email to create a free account\n        "
                      ),
                    ]
                  )
                : _c(
                    "label",
                    {
                      staticClass: "margin-0 display-inline-block",
                      staticStyle: {
                        cursor: "pointer",
                        "font-weight": "700",
                        color: "var(--fa-dk-gravy)",
                      },
                      attrs: { for: "email" },
                    },
                    [
                      _vm._v("\n          Enter your email to\n          "),
                      _c(
                        "span",
                        { staticClass: "display-none tablet:display-inline" },
                        [_vm._v("get started")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tablet:display-none" }, [
                        _vm._v("start"),
                      ]),
                      _vm._v("\n          with a free Kit!\n        "),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "padding-x-3xs",
                  attrs: {
                    href: "#",
                    "aria-label": "Why do we need your email?",
                    "data-balloon-pos": "up",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showWhyEmailModal.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v7.solid.faCircleQuestion,
                      "aria-hidden": "true",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.isShowingCloudflare
              ? _c(
                  "div",
                  {
                    staticClass:
                      "display-none laptop:display-block laptop:column-4 text-right",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "text-nowrap",
                        attrs: {
                          href: "https://www.cloudflare.com/?utm_source=FontAwesome&utm_medium=website&utm_campaign=Marketing%20Sponsorship",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "referral:powered_by_cloudflare_link_click",
                              { context: "start_view" }
                            )
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "size-sm" }, [
                          _vm._v("Powered by Cloudflare"),
                        ]),
                        _c("font-awesome-icon", {
                          staticClass: "margin-left-3xs",
                          attrs: {
                            icon: _vm.$v7.brands.faCloudflare,
                            size: "2xl",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.errors.hasAny
            ? _vm._l(_vm.errors.messages, function (message) {
                return _c("owa-message", {
                  key: message,
                  attrs: { theme: "danger", content: message, type: "flash" },
                })
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row align-top" }, [
            _c(
              "div",
              { staticClass: "column-12 laptop:column-8" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  ref: "email",
                  staticClass: "margin-0",
                  class: { danger: _vm.errors.hasAny },
                  attrs: {
                    id: "email",
                    name: "email",
                    type: "email",
                    placeholder: "e.g. violet@freshsqueezed.org",
                    autocapitalize: "none",
                    autocorrect: "off",
                    required: "",
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("owa-accept-policies-checkbox", {
                  staticClass:
                    "margin-top-md margin-bottom-xl laptop:margin-bottom-0",
                  model: {
                    value: _vm.acceptPolicies,
                    callback: function ($$v) {
                      _vm.acceptPolicies = $$v
                    },
                    expression: "acceptPolicies",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column-12 laptop:column-4" },
              [
                _vm.hasArrivedFromFigma
                  ? _c("owa-action-button", {
                      staticStyle: { "--form-button-margin": "0" },
                      attrs: {
                        "is-processing": _vm.isSending,
                        "icon-name": "faRocketLaunch",
                        "is-full-width": "",
                        "is-processing-label": "Sending...",
                        label: "Create Your Free Account",
                        theme: "accent",
                      },
                      on: { click: _vm.initiateFreeAccount },
                    })
                  : _c("owa-action-button", {
                      staticStyle: {
                        "--form-button-margin": "0",
                        "--button-hover-background": "var(--fa-yellow)",
                      },
                      attrs: {
                        "is-processing": _vm.isSending,
                        "icon-name": "faGlobe",
                        "is-full-width": "",
                        "is-processing-label": "Setting up...",
                        label: "Start for Free",
                        theme: "info",
                      },
                      on: { click: _vm.initiateFreeAccount },
                    }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row align-middle margin-top-xl laptop:margin-top-lg",
                  },
                  [
                    _vm.isShowingCloudflare
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "column-4 tablet:column-7 laptop:display-none",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "text-nowrap",
                                attrs: {
                                  href: "https://www.cloudflare.com/?utm_source=FontAwesome&utm_medium=website&utm_campaign=Marketing%20Sponsorship",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "referral:powered_by_cloudflare_link_click",
                                      { context: "start_view" }
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "size-sm" }, [
                                  _vm._v("Powered by Cloudflare"),
                                ]),
                                _c("font-awesome-icon", {
                                  staticClass: "margin-left-3xs",
                                  attrs: {
                                    icon: _vm.$v7.brands.faCloudflare,
                                    size: "2xl",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          "column-8 laptop:column-12 text-right",
                          _vm.isShowingCloudflare
                            ? "tablet:column-5"
                            : "tablet:column-12",
                        ],
                      },
                      [
                        _c(
                          "site-link",
                          {
                            staticClass: "display-inline-block",
                            attrs: { to: _vm.routes.signIn.location },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.$posthog.capture(
                                  "sign_in_button_click",
                                  { context: "start_view" }
                                )
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "size-sm" }, [
                              _vm._v("Already have an account?"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("modal-why-email", {
        attrs: {
          "is-showing": _vm.isShowingWhyEmailModal,
          "has-arrived-from-figma": _vm.hasArrivedFromFigma,
        },
        on: { "close-modal": _vm.hideWhyEmailModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }